import { EmptyState } from 'components/EmptyState';
import { Flex, Skeleton } from 'antd';
import { GoBack } from '../../professor_area/GoBack';
import { ReactNode } from 'react';
import { Show, ShowProps } from '@refinedev/antd';

interface ShowLayoutProps<T> extends ShowProps {
  children: ReactNode;
  backLabel?: ReactNode;
  isLoading?: boolean;
  isFetched?: boolean;
  record?: T;
  EmptyStateComponent?: ReactNode;
}

export const ShowLayout = <T,>({
  children,
  backLabel,
  isLoading,
  isFetched,
  record,
  EmptyStateComponent = <EmptyState description="Nenhum dado encontrado" />,
  ...props
}: ShowLayoutProps<T>) => {
  const renderContent = () => {
    if (isFetched && !isLoading && !record) {
      return EmptyStateComponent;
    }
    return children;
  };

  if (isLoading) {
    return (
      <Flex vertical gap={16}>
        <Skeleton
          active
          title={false}
          paragraph={{
            rows: 1,
            style: {
              margin: 0
            }
          }}
        />
        <Skeleton.Node active style={{ width: '100%', height: '120px' }} />
        <Skeleton active paragraph={{ rows: 6 }} />
      </Flex>
    );
  }

  return (
    <Show
      {...props}
      headerProps={{
        title: false
      }}
      goBack={<GoBack label={backLabel || 'Voltar'} />}
      headerButtonProps={{
        hidden: true
      }}
      wrapperProps={{
        className: 'custom-layout'
      }}
      contentProps={{
        className: '!bg-transparent !shadow-none',
        styles: {
          cover: {
            background: 'red'
          },
          body: {
            padding: 0,
            backgroundColor: 'transparent',
            height: '100%'
          }
        }
      }}
    >
      {renderContent()}
    </Show>
  );
};
